import * as firebase from "firebase";
// import firebase from 'firebase/app'
import "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

// const firebaseConfig = {
//     apiKey: "lala",
//     databaseURL: "http://localhost:9000/?ns=macadamia-vanphuc",
//     projectId: "macadamia-vanphuc",
// }

firebase.initializeApp(firebaseConfig);
// firebase.analytics();

// firebase.functions().useFunctionsEmulator("http://localhost:5001");

const database = firebase.database();
const storage = firebase.storage();

window.firebase = firebase;
window.database = database;

export { firebase, database, database as default, storage };
